import { Partner } from './partner.model';
import { User } from './user.model';
import { UPMessage } from './up-message.model';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '../modules/crud';

@CwtModel({ name: 'up-conversation', path: '/up-conversation' })
export class UPConversation extends ApiData {
    partner: Partner;
    user: User;
    isReadByPartner: boolean;
    lastMessage: UPMessage;

    fieldDictionary() {
        return {
            partner: Partner,
            user: User
        };
    }
}
